<template>
  <span>Not Found</span>
</template>
<script>
export default {
  data () {
    return {
      context: 'login context',
      loaded: false,
      data: {
        body: {
          username: '',
          password: ''
        },
        rememberMe: false,
        fetchUser: true
      },
      error: null
    }
  },
  ready () {
    var _this = this
    // Set up $auth.ready with other arbitrary loaders (ex: language file).
    setTimeout(function () {
      _this.loaded = true
    }, 500)
    // Test manual refresh on boot (instead of via plugin).
    // if (this.$auth.token()) {
    //   this.$auth.refresh()
    // }
  },
  mounted () {
    console.log(this.$auth.redirect())
    // Can set query parameter here for auth redirect or just do it silently in login redirect.
  },
  methods: {
    login () {
      var redirect = this.$auth.redirect()
      this.$auth.login({
        body: this.data.body, // Vue-resource
        data: this.data.body, // Axios
        rememberMe: this.data.rememberMe,
        redirect: {name: redirect ? redirect.from.name : 'account'},
        fetchUser: this.data.fetchUser
        // window.localStorage.setItem('id_token', data.id_token)
      })
      .then(() => {
        console.log('success ' + this.context)
        const token = this.$auth.token()
        console.log('login success ' + token)
        this.$store.commit('SET_AUTH_TOKEN', token)
      }, (res) => {
        console.log('error ' + this.context)
        this.error = res.data
      })
    },
    logout () {
      this.$auth.logout({
        makeRequest: true,
        // window.localStorage.removeItem('id_token'),
        success () {
          console.log('success ' + this.context)
        },
        error () {
          console.log('error ' + this.context)
        }
      })
    },
    unimpersonate () {
      this.$auth.unimpersonate({
        success () {
          console.log('success ' + this.context)
        },
        error () {
          console.log('error ' + this.context)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/NotFoundView.vue